import React from 'react'

const UnderDevelopment: React.FC = () => (
  <p className="p-3 font-italic">This feature is still under development</p>
)

export default React.memo(UnderDevelopment)
